import * as React from 'react';
import { useCallback, useEffect } from 'react';
import _ from 'lodash';

export const Tooltip = ({ left, text }) => {
    return (
        <div style={{ left }} className={`z-10 absolute translate-x-[-50%] bottom-[28px]`}>
            <div className='arrow-standard left-1/2 absolute'></div>
            <div className='shadow-standard font-forms bg-white p-2 whitespace-nowrap'>{text}</div>
        </div>
    )
}

